import React from 'react';

import classNames from 'classnames';

import styles from './meetup-icon.module.scss';

interface Props {
	className?: string;
}

export const MeetupIcon = ({ className }: Props) => {
	return (
		<div data-test-id="meetup-icon" className={classNames(styles.meetupIcon, className)}>
			M
		</div>
	);
};
